export default function ExperiencesHero() {
  return (
    <section className="relative w-full h-[70vh] min-h-[500px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/77fc6fb8e0c02bdf43345efeaf15ea6e.jpg"
        alt="Table Privé experiences"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
        <p className="text-[#C9A961] tracking-[0.3em] text-xs uppercase font-light mb-6">
          Tailored to You
        </p>
        <h1 className="font-serif text-white text-5xl md:text-6xl lg:text-7xl font-normal leading-[1.1] mb-6">
          Curated Experiences
        </h1>
        <div className="h-px w-20 bg-[#C9A961]/70" />
        <p className="text-white/70 text-base md:text-lg font-light leading-relaxed max-w-xl mt-6">
          Each offering is a singular creation — designed around your guests, your vision, and your moment.
        </p>
      </div>
    </section>
  );
}
